import React, { useState, useRef, useEffect, } from "react";
import { View, TouchableOpacity } from "react-native";
import Button from "components/Partials/Buttons";
import PatientProfileImage from "components/Partials/PatientProfileImage.js";

const PatientEditImage = ({ profile_image_id, onImageChange }) => {
  const [isHovering, setHovering] = useState(false);
  const fileInputRef = useRef();
  const isMobile = window.main.platform_os !== "web" || (typeof navigator !== "undefined" && /Android|iPhone|iPad/i.test(navigator.userAgent)); // https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system

  // Handle file selection
  const handleFileChange = (event) => {
    setHovering(false);
    const file = event.target.files && event.target.files[0];
    if (file && typeof onImageChange === "function") {
      onImageChange(file);
    }
  };

  // Handle clicking the photo or upload button
  const handleImageClick = () => {
    setHovering(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // allow uploading same file twice
      fileInputRef.current.click();
    }
  };
  const hoverProps = {
    onMouseEnter: () => setHovering(true),
    onMouseLeave: () => setHovering(false),
  };

  return (
    <View style={{alignItems:"center",justifyContent:"center",marginBottom:0,position:"relative"}} {...hoverProps}>
      <TouchableOpacity activeOpacity={0.8} onPress={handleImageClick}>
        <PatientProfileImage profile_image_id={profile_image_id} style={{width:72,height:72,marginRight:0}} />
        {(isHovering || isMobile) && (
          <Button type="secondary" ficon="camera" size="icon" style={{backgroundColor:"#fff",borderRadius:0,borderWidth:0,elevation:1,height:0,padding:0,position:"absolute",right:4,top:4,width:0,zIndex:20}} iconSize={18} onPress={handleImageClick} />
        )}
      </TouchableOpacity>
      <input type="file" accept="image/*" style={{ display: "none" }} ref={fileInputRef} onChange={handleFileChange}/>
    </View>
  );
};
export default PatientEditImage;